import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Chunk loading error detection and auto-recovery
let refreshAttempted = false;

// Detect chunk loading errors and auto-refresh once
window.addEventListener('error', (e) => {
  const isChunkError = e.message && (
    e.message.includes('Loading chunk') ||
    e.message.includes('Unexpected token') ||
    e.message.includes('ChunkLoadError')
  );

  if (isChunkError && !refreshAttempted) {
    refreshAttempted = true;
    console.warn('Chunk loading error detected, refreshing page...', e.message);
    // Clear cache and reload
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    window.location.reload();
  }
});

// Also catch unhandled promise rejections from chunk loading
window.addEventListener('unhandledrejection', (e) => {
  const isChunkError = e.reason && e.reason.name === 'ChunkLoadError';

  if (isChunkError && !refreshAttempted) {
    refreshAttempted = true;
    console.warn('Chunk loading promise rejection detected, refreshing page...', e.reason);
    // Clear cache and reload
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    window.location.reload();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
